// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hint{display:inline-flex;align-items:center}.hint__title{margin-right:5px}", "",{"version":3,"sources":["webpack://./src/components/hint/hint.scss"],"names":[],"mappings":"AAAA,MACE,mBAAA,CACA,kBAAA,CAEA,aACE,gBAAA","sourcesContent":[".hint {\n  display: inline-flex;\n  align-items: center;\n\n  &__title {\n    margin-right: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
